module.exports = __webpack_public_path__ + "media/images/glg-premium-17cce92092c719fb980d39217cc9fe17.png";